const dataAttributesToProps = (element) => {
    const props = {};
    for (let i = element.attributes.length - 1; i >= 0; i -= 1) {
        const attr = element.attributes[i];
        if (attr.name.startsWith('data-')) {
            const propName = attr.name.substring(5);
            let value = attr.value;
            if (value === 'True') {
                value = true;
            } else if (value === 'False') {
                value = false;
            }
            props[propName] = value;
            element.removeAttribute(attr.name);
        }
    }
    return props;
};
export default dataAttributesToProps;


